'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _HotelItem = require('../containers/HotelItem.js');

var _HotelItem2 = _interopRequireDefault(_HotelItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: move style to CSS file
// HotelList

function HotelList(_ref) {
  var i18n = _ref.i18n,
      items = _ref.items,
      location = _ref.location,
      search = _ref.search;

  return _react2.default.createElement(
    'div',
    { className: 'hotel-listing', style: { width: '100%' } },
    items.map(function (item) {
      return _react2.default.createElement(_HotelItem2.default, { i18n: i18n, item: item, location: location, search: search, key: item.id });
    })
  );
}

HotelList.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  items: _react.PropTypes.array.isRequired,
  location: _react.PropTypes.object.isRequired,
  search: _react.PropTypes.object.isRequired
};

exports.default = HotelList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/HotelList.js
// module id = 576
// module chunks = 0